// Only local absolute paths are allowed, including after URL normalization.
export const safeReturnTo = (value) => {
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//')) return '/';
  // Reject controls and backslashes before the URL parser can normalize them.
  if (Array.from(value).some((char) => char === '\\' || char.charCodeAt(0) < 32 || char.charCodeAt(0) === 127)) return '/';
  if (/%(?:0[0-9a-f]|1[0-9a-f]|5c|7f)/i.test(value)) return '/';
  // Encoded separators are unsafe in a path, but normal in a query value.
  if (/%2f/i.test(value.split(/[?#]/)[0])) return '/';
  try {
    const url = new URL(value, window.location.origin);
    if (url.origin !== window.location.origin || url.pathname.startsWith('//')) return '/';
    return `${url.pathname}${url.search}${url.hash}`;
  } catch (_) {
    return '/';
  }
};
